import { Reveal } from "@/components/shared/Reveal";
import { ArrowRight, Building2 } from "lucide-react";
import { openPreRegister } from "@/lib/preRegisterModal";

export const CarrierEarlyAccess = () => (
  <section id="carrier-early-access" data-testid="carrier-early-access-section" className="py-20 md:py-28 bg-rr-navy relative overflow-hidden">
    <div className="grain-overlay" />
    <div className="max-w-3xl mx-auto px-5 md:px-8 text-center relative">
      <Reveal>
        <div className="inline-flex items-center gap-2 text-rr-orangeLight text-xs font-bold tracking-[0.2em] uppercase mb-5">
          <Building2 size={14} /> RelayRigs for Carriers
        </div>
        <h2 data-testid="carrier-early-access-heading" className="font-heading text-3xl md:text-5xl font-extrabold text-white leading-tight tracking-tight">
          Get Early Access to the RelayRigs Driver Network
        </h2>
        <button
          onClick={() => openPreRegister("carrier")}
          data-testid="carrier-early-access-cta"
          className="mt-9 inline-flex items-center gap-2 bg-rr-orange text-white font-bold px-8 py-4 rounded-full hover:bg-white hover:text-rr-navy transition-all hover:-translate-y-1"
        >
          Request Carrier Early Access <ArrowRight size={18} />
        </button>
      </Reveal>
    </div>
  </section>
);
